import { Component, Input } from '@angular/core';

import { FormControlsBase, providerFormControlsBase } from '../form-controls.base';
import { ControlContainer } from '@angular/forms';

@Component({
  selector: 'bvl-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  providers: [providerFormControlsBase(BvlFormInputComponent)]
})
export class BvlFormInputComponent extends FormControlsBase {

  @Input() icon: string;

  protected _type: string;
  @Input()
  get type(): string {
    return this._type;
  }
  set type(type: string) {
    this._type = type || 'text';
  }

  localType;

  constructor(controlContainer: ControlContainer) {
    super(controlContainer);
    this._type = 'text';
  }

  ngOnInit() {
    this.localType = JSON.parse(JSON.stringify(this.type))
  }

  clearInput(): void {
    this.model = '';
  }

  togglePassword(): void {
    this.localType = this.localType === 'password' ? 'text' : 'password'
  }
}
